import { z } from 'zod';
import { CONTACT_FORM_DEFAULT_VALUES, contactSchema } from '@lp/features/admin/forms/MainContactForm';
import { ContactFormValues } from '@/types';

export const DEFAULT_HOSPITAL_CONTACT_VALUES: ContactFormValues = {
  parentId: '',
  parentName: '',
  ...CONTACT_FORM_DEFAULT_VALUES,
};

export const contactLocationSchema = z.object({
  parentId: z.string().min(1, 'Select Contact location'),
  parentName: z.string(),
});

export const hospitalContactFormSchema = contactLocationSchema.extend(contactSchema.shape);
